// DashboardLayout.jsx
import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

const DashboardLayout = ({ children }) => {
  return (
    <div className="h-screen flex bg-gray-50 overflow-hidden">
      {/* Fixed Sidebar */}
      <Sidebar />

      {/* Main Content Area - with left margin to account for sidebar */}
      <div className="flex-1 flex flex-col ml-20 lg:ml-64 transition-all duration-300">
        {/* Header - Fixed at top */}
        <Header />

        {/* Main Content - Scrollable */}
        <main className="flex-1 overflow-y-auto bg-gradient-to-br from-blue-50 via-white to-purple-50">
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
